import { CustomButton, CustomInput, TextInput } from '@/shared/ui/components';
import { withModalLayout } from '@/shared/lib';
import { t } from 'ttag';
import { useLearnMoreModal } from './useLearnMoreModal';
import type { LearnMoreModalProps } from './learnMoreModal.types';
import './learnMoreModal.scss';

/**
 * Marketing banner lead-capture form collecting name, facility name, phone number and optional email for a consulting request. Reads state, content, onChange and onClickSend from useLearnMoreModal, renders each field with its validation error and disables them while submitting, and is wrapped in withModalLayout so the hook can set the modal title.
 *
 * @param onCancel - Callback closing the modal.
 * @param setTitle - Setter used by the hook to publish the modal title.
 * @param type - Consulting request type the submission is filed under.
 * @returns The rendered form element.
 */
const LearnMoreModal = withModalLayout((({ onCancel, setTitle, type }: LearnMoreModalProps) => {
  const { state, content, onChange, onClickSend } = useLearnMoreModal({ onCancel, setTitle, type });

  return (
    <div className="learn-more-modal">
      <span className="description">{content.description}</span>

      <CustomInput
        name="name"
        title={t`Name`}
        placeholder={t`Enter name`}
        value={state.name}
        onChange={onChange}
        disabled={state.isSubmit}
        isError={!!state.errors.name}
        errorMessage={state.errors.name}
        size="middle"
      />
      <CustomInput
        name="facilityName"
        title={t`Facility name`}
        placeholder={t`Enter facility name`}
        value={state.facilityName}
        onChange={onChange}
        disabled={state.isSubmit}
        isError={!!state.errors.facilityName}
        errorMessage={state.errors.facilityName}
        size="middle"
      />
      <TextInput
        name="phoneNumber"
        label={t`Phone number`}
        placeholder={t`Enter phone number`}
        isPhoneNumberMask
        value={state.phoneNumber}
        onChange={onChange}
        disabled={state.isSubmit}
        isError={!!state.errors.phoneNumber}
        errorMessage={state.errors.phoneNumber}
        hasErrorIcon
      />
      <CustomInput
        name="contactEmail"
        title={
          (
            <div>
              {t`Email`}
              <span className="sub-title">{t` (optional)`}</span>
            </div>
          ) as any
        }
        placeholder={t`Enter email`}
        value={state.contactEmail}
        onChange={onChange}
        disabled={state.isSubmit}
        isError={!!state.errors.contactEmail}
        errorMessage={state.errors.contactEmail}
        size="middle"
      />

      <div className="row-button">
        <CustomButton
          id="submit-learn-more-btn"
          onClick={onClickSend}
          loading={state.isSubmit}
          size="middle"
        >
          {t`Submit`}
        </CustomButton>
      </div>
    </div>
  );
}) as any);

(LearnMoreModal as any).defaultProps = {
  width: 600,
};

export default LearnMoreModal;
